import { InternalLink } from '../../../../../components/Clickables/InternalLink/InternalLink';
import { getFishingWaterUrl } from '../../../../../helpers/urls';
import { GetFishingWaterNearbyWaters_fishingWater_suggestedWaters } from '../../../../../interfaces/graphql';

interface IProps {
  SEOFishingSpots: GetFishingWaterNearbyWaters_fishingWater_suggestedWaters[];
}

/**
 * Component that renders a list of SEO-friendly internal links for fishing spots.
 * The links are hidden from the user interface but can be used by search engines for SEO purposes.
 *
 * @component
 * @param {IProps} props - The properties object.
 * @param {GetFishingWaterNearbyWaters_fishingWater_suggestedWaters[]} props.SEOFishingSpots - An array of suggested fishing water spots.
 * @returns {JSX.Element} A hidden div containing internal links to the fishing water spots.
 */
export const MapSEOLinks = ({ SEOFishingSpots }: IProps) => {
  return (
    <div className="hidden">
      {SEOFishingSpots.map(({ _id, displayName }) => (
        <InternalLink key={_id} to={getFishingWaterUrl(_id, displayName)}>
          {displayName}
        </InternalLink>
      ))}
    </div>
  );
};
